export const TRANSLATION_GROUP_NEW_APP_VERSION = Symbol('new-app-version');

export const LOCAL_STAT_FILE_QUERY_KEY = 'locale-stat-file';

export const REQUEST_INTERVAL = 1000 * 60 * 30; // 30 minutes
